export const localStorageTokenName = "aqua-app-token";
